import { MotionConfig } from 'motion/react';
import { StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router/dom';
import { Spinner } from './components/ui/Spinner';
import { appConfig } from './lib/config';
import { initTheme } from './lib/theme';
import { preloadGameScreens, router } from './router';
import './styles.css';

initTheme();
// Warm up the runtime config so Street View doesn't wait for it later.
void appConfig();

preloadGameScreens();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Suspense
      fallback={
        <div className="grid h-full place-items-center">
          <Spinner className="size-8 text-ink-400" />
        </div>
      }
    >
      {/* Players who ask their system for less motion get fades instead of slides and pops. */}
      <MotionConfig reducedMotion="user">
        <RouterProvider router={router} />
      </MotionConfig>
    </Suspense>
  </StrictMode>,
);
